import { render, staticRenderFns } from "./LiftAdd.vue?vue&type=template&id=17b5054a&scoped=true&"
import script from "./LiftAdd.vue?vue&type=script&lang=js&"
export * from "./LiftAdd.vue?vue&type=script&lang=js&"
import style0 from "./LiftAdd.vue?vue&type=style&index=0&id=17b5054a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b5054a",
  null
  
)

export default component.exports